import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from '@/hooks/useAuth';

interface OrganizationSettings {
  id: string;
  name: string;
  logo_url?: string;
}

export const useOrganizationSettings = () => {
  const { user } = useAuth();
  const [settings, setSettings] = useState<OrganizationSettings | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSettings = async () => {
      if (!user?.org_id) {
        setLoading(false);
        return;
      }

      try {
        const { data, error } = await supabase
          .from('organizations')
          .select('id, name, logo_url')
          .eq('id', user.org_id)
          .single();

        if (error) throw error;
        setSettings(data);
      } catch (error) {
        console.error('Error fetching organization settings:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchSettings();
  }, [user?.org_id]);

  return { settings, loading };
};
